import { defineCustomElement } from 'vue'
import router from './infrastructure/router.ts';
import i18n from './infrastructure/i18n.ts';
import App from './App.vue'
import allStyles from './styles.all.css?inline'
import licStyles from './styles.lic.css?inline'

const GfoCheckout = defineCustomElement(App, {
  configureApp(app) {
    app.use(router)
    app.use(i18n)
  },
  styles: [allStyles, licStyles],
})

customElements.define('gfo-checkout', GfoCheckout)
